/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageSuccess = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m20.293 16.293 1.414 1.414L17 22.414l-2.707-2.707 1.414-1.414L17 19.585zM14.414 2l.31.31.015.015L21 8.585V13h-2v-3h-6V4H5v16h7v2H3V2zM13 16v2H7v-2zm4-4v2H7v-2zm-2-6.585V8h2.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPageSuccess as PageSuccess };
